// Verified project + community content for calmingstorm.net.
// OWNED by the content/accuracy pass — facts verified against each project's
// source/memory at 2026-07-12. Design binds these; do not author project facts
// in presentation code. If a different shape is needed, request it and this
// module changes, not the components.

export interface Project {
  name: string
  desc: string
  url: string
  color: string // decorative accent; safe for design to re-theme for palette cohesion
  tags: string[]
  live: boolean
}

// Lineup order is deliberate: Odin, EveFit, Bastion, then GitHub.
// (Heimdall retired from the lineup — superseded by Odin.)
export const projects: Project[] = [
  {
    name: 'Odin',
    desc: 'Autonomous Discord execution agent — runs real tools on real infrastructure from chat, with safety rails and validation.',
    url: 'https://odin-bot.net',
    color: '#c58b32',
    tags: ['Python', 'Discord', 'Codex / GPT-5', 'Open Source'],
    live: true,
  },
  {
    name: 'EveFit',
    desc: 'EVE Online ship fitting tool — plan builds, calculate stats, share fits.',
    url: 'https://evefit.online',
    color: '#4a9eff',
    tags: ['Vue 3', 'TypeScript', 'Node.js', 'MariaDB'],
    live: true,
  },
  {
    name: 'Bastion',
    desc: 'Open-source, self-hostable Discord alternative — privacy-first chat you run yourself.',
    url: 'https://bastions.org',
    color: '#10b981',
    tags: ['Go', 'React', 'PostgreSQL', 'WebSocket'],
    live: true,
  },
  {
    name: 'GitHub',
    desc: 'Open source projects, contributions, and experiments.',
    url: 'https://github.com/Calmingstorm',
    color: '#f59e0b',
    tags: ['Open Source'],
    live: false,
  },
]

// Community + support links that MUST remain visible somewhere on the site.
export const community = {
  discord: 'https://discord.gg/Q5kJw66Rks',
  donate: 'https://paypal.me/eutopic?country.x=US&locale.x=en_US',
}

// Replaces the old about-section sentence that referenced Heimdall.
export const aboutBlurb =
  "A small, self-hosted Minecraft community running modded servers on dedicated hardware — no paid ranks, no pay-to-win, no compromises. Every server is free and always will be. When we're not building factories or exploring dungeons, we're building tools like EveFit and autonomous systems like Odin."
